export const MOCK_NAVIGATION_SECONDARY_LINKS = [
    { reference: 'verkeer', href: '/verkeer', label: '666 km files' },
    {
        reference: 'route-planner',
        href: '/verkeer/routeplanner?rplherk=navigatiebalk',
        label: 'Routeplanner',
    },
    {
        reference: 'winkels',
        href: '/contact-en-service/anwb-winkels',
        label: 'Winkels',
    },
    {
        reference: 'contact-en-service',
        href: '/contact-en-service',
        label: 'Contact & service',
    },
];
